// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 28Wh6oQMGtkZtGs1aVzLHN
// Component: 3c5EQnD-_tWA
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import HomepageNavbar from "../../HomepageNavbar"; // plasmic-import: xTJEhzpCCql/component
import HomepageFooter from "../../HomepageFooter"; // plasmic-import: lnNBtyPw6r3/component
import { useScreenVariants as useScreenVariantsjSnjRsWLwTjq } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: JSnjRsWLwTjq/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_origin.module.css"; // plasmic-import: 28Wh6oQMGtkZtGs1aVzLHN/projectcss
import sty from "./PlasmicAbout.module.css"; // plasmic-import: 3c5EQnD-_tWA/css
import hrsPngPtiubCYvf from "./images/hrsPng.jpg"; // plasmic-import: ptiubCYvf/picture
import image2LhqDznIcG from "../bela_griva/images/image2.jpg"; // plasmic-import: lhqDZNIcG/picture
import img7469JpgILnOvoy0K from "../bela_griva/images/img7469Jpg.jpg"; // plasmic-import: iLnOVOY0k/picture
import img7524JpgZ0QYkRtN7 from "../bela_griva/images/img7524Jpg.jpg"; // plasmic-import: Z0qYKRtN7/picture
import img7148JpgBYdJdgkK from "../bela_griva/images/img7148Jpg.jpg"; // plasmic-import: bYDJdgk_K/picture

export const PlasmicAbout__VariantProps = new Array();

export const PlasmicAbout__ArgProps = new Array();

const __wrapUserFunction =
  globalThis.__PlasmicWrapUserFunction ?? ((loc, fn) => fn());

const __wrapUserPromise =
  globalThis.__PlasmicWrapUserPromise ??
  (async (loc, promise) => {
    return await promise;
  });

function PlasmicAbout__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const [$queries, setDollarQueries] = React.useState({});
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsjSnjRsWLwTjq()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <p.Stack
          as={"div"}
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          hasGap={true}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            sty.root
          )}
        >
          <HomepageNavbar
            data-plasmic-name={"homepageNavbar"}
            data-plasmic-override={overrides.homepageNavbar}
            className={classNames("__wab_instance", sty.homepageNavbar)}
          />

          <div className={classNames(projectcss.all, sty.freeBox__teGBb)}>
            <div className={classNames(projectcss.all, sty.freeBox__eqKif)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__fFSwv
                )}
              >
                {"O školi jahanja Bela Griva"}
              </div>
              {(
                hasVariant(globalVariants, "screen", "mobileOnly") ? true : true
              ) ? (
                <p.PlasmicImg
                  alt={""}
                  className={classNames(sty.img__b2QqL)}
                  displayHeight={"392px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"514px"}
                  loading={"lazy"}
                  src={{
                    src: hrsPngPtiubCYvf,
                    fullWidth: 1200,
                    fullHeight: 1600,
                    aspectRatio: undefined
                  }}
                />
              ) : null}
              {(
                hasVariant(globalVariants, "screen", "mobileOnly")
                  ? true
                  : false
              ) ? (
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__cy9Sn
                  )}
                >
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#000000" }}
                    >
                      {
                        "Školu jahanja ,,Bela griva” osnovala je i vodi trener sa dugogodišnjim iskustvom, licencom Saveza za konjički sport, olimpijske i fei discipline Srbije, kao i licencom Galopskog saveza, dipl. prof. fizičkog vaspitanja, Sanja Dabović.  Primarni cilj škole je povećati dostupnost, a time i popularnost i rasprostranjenost konjičkog sporta u Srbiji."
                      }
                    </span>
                  </React.Fragment>
                </div>
              ) : null}
              <div className={classNames(projectcss.all, sty.columns__jaCbY)}>
                <div className={classNames(projectcss.all, sty.column__ajQv)}>
                  <div
                    className={classNames(projectcss.all, sty.columns__soO0)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.column___2Usu5)}
                    />

                    {(
                      hasVariant(globalVariants, "screen", "mobileOnly")
                        ? true
                        : true
                    ) ? (
                      <div
                        data-plasmic-name={"whiteContainer"}
                        data-plasmic-override={overrides.whiteContainer}
                        className={classNames(
                          projectcss.all,
                          sty.whiteContainer
                        )}
                      >
                        {true ? (
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__u4Gfl
                            )}
                          >
                            <React.Fragment>
                              <span
                                className={
                                  "plasmic_default__all plasmic_default__span"
                                }
                                style={{ color: "#000000" }}
                              >
                                {
                                  "Školu jahanja ,,Bela griva” osnovala je i vodi trener sa dugogodišnjim iskustvom, licencom Saveza za konjički sport, olimpijske i fei discipline Srbije, kao i licencom Galopskog saveza, dipl. prof. fizičkog vaspitanja, Sanja Dabović.  Primarni cilj škole je povećati dostupnost, a time i popularnost i rasprostranjenost konjičkog sporta u Srbiji."
                                }
                              </span>
                            </React.Fragment>
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                  {(
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? true
                      : true
                  ) ? (
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__tCkF4
                      )}
                    >
                      {"Enter some text"}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox___8IVWe)}>
            <div className={classNames(projectcss.all, sty.freeBox__fgdM)}>
              <div className={classNames(projectcss.all, sty.columns__hHvRj)}>
                <div className={classNames(projectcss.all, sty.column__k2VTd)}>
                  <div
                    className={classNames(projectcss.all, sty.columns__qSbPt)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.column___2VI)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__hJlKd
                        )}
                      >
                        {
                          "Polaznicima svih uzrasta da se na bezbedan i njima prilagođen način okušaju u jahanju. U okviru škole jahanja, pored časova jahanja, organizujemo ,,team building”, kampove na raznim lokacijama, rođendane uz animatore sa desetogodišnjim iskustvom, malu školicu konjičkog sporta i produženi boravak na otvorenom, u zdravom ambijentu, vođen od strane diplomiranih master učitelja."
                        }
                      </div>
                    </div>
                    <div
                      className={classNames(projectcss.all, sty.column__p7ScL)}
                    >
                      {(
                        hasVariant(globalVariants, "screen", "mobileOnly")
                          ? true
                          : true
                      ) ? (
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__o3Qoi
                          )}
                        >
                          {hasVariant(globalVariants, "screen", "mobileOnly")
                            ? "Bilo da prvi put sedate na konja, jašete rekreativno, početnik ste koji žele postati profesionalac ili ste profesionalac koji želi da usavrši svoju tehniku, škola jahanja ,,Bela griva” pravo je mesto za Vas. \n\nŠkola sportskog i rekreativnog jahanja ,,Bela Griva” nalazi se na beogradskom hipodromu. U radu škole, pored profesionalnih, licenciranih  trenera angažovan je i stručni pedagoški  kadar.  Ovo daje mogućnost polaznicima svih uzrasta da se na bezbedan i njima prilagođen način okušaju u jahanju."
                            : "Bilo da prvi put sedate na konja, jašete rekreativno, početnik ste koji žele postati profesionalac ili ste profesionalac koji želi da usavrši svoju tehniku, škola jahanja ,,Bela griva” pravo je mesto za Vas. \n\nŠkola sportskog i rekreativnog jahanja ,,Bela Griva” nalazi se na beogradskom hipodromu. U radu škole, pored profesionalnih, licenciranih  trenera angažovan je i stručni pedagoški  kadar.  Ovo daje mogućnost polaznicima svih uzrasta da se na bezbedan i njima prilagođen način okušaju u jahanju."}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {true ? (
            <div className={classNames(projectcss.all, sty.freeBox__beD7K)}>
              {(
                hasVariant(globalVariants, "screen", "mobileOnly") ? true : true
              ) ? (
                <p.PlasmicImg
                  alt={""}
                  className={classNames(sty.img__bnKNs)}
                  displayHeight={
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? "485px"
                      : "686px"
                  }
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? "567px"
                      : "1452px"
                  }
                  loading={"lazy"}
                  src={{
                    src: image2LhqDznIcG,
                    fullWidth: 4680,
                    fullHeight: 3120,
                    aspectRatio: undefined
                  }}
                />
              ) : null}
            </div>
          ) : null}
          {true ? (
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__ojRq)}
            >
              {(
                hasVariant(globalVariants, "screen", "mobileOnly") ? true : true
              ) ? (
                <div className={classNames(projectcss.all, sty.freeBox__rssZf)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__p242
                    )}
                  >
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#000000" }}
                      >
                        {"Engleski stil jahanja"}
                      </span>
                    </React.Fragment>
                  </div>
                  <p.PlasmicImg
                    alt={""}
                    className={classNames(sty.img__rDPiU)}
                    displayHeight={"auto"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"100%"}
                    loading={"lazy"}
                    src={{
                      src: img7469JpgILnOvoy0K,
                      fullWidth: 4680,
                      fullHeight: 3120,
                      aspectRatio: undefined
                    }}
                  />
                </div>
              ) : null}
              {(
                hasVariant(globalVariants, "screen", "mobileOnly") ? true : true
              ) ? (
                <div className={classNames(projectcss.all, sty.freeBox__e9D9R)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__e34YY
                    )}
                  >
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#000000" }}
                      >
                        {"Preponsko Jahanje"}
                      </span>
                    </React.Fragment>
                  </div>
                  <p.PlasmicImg
                    alt={""}
                    className={classNames(sty.img__wNkwi)}
                    displayHeight={"auto"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"100%"}
                    loading={"lazy"}
                    src={{
                      src: img7524JpgZ0QYkRtN7,
                      fullWidth: 4680,
                      fullHeight: 3120,
                      aspectRatio: undefined
                    }}
                  />
                </div>
              ) : null}
              {(
                hasVariant(globalVariants, "screen", "mobileOnly") ? true : true
              ) ? (
                <div className={classNames(projectcss.all, sty.freeBox__hu5Wh)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___4PEyX
                    )}
                  >
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#000000" }}
                      >
                        {"Galopske trke"}
                      </span>
                    </React.Fragment>
                  </div>
                  <p.PlasmicImg
                    alt={""}
                    className={classNames(sty.img__varoS)}
                    displayHeight={"auto"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"100%"}
                    loading={"lazy"}
                    src={{
                      src: img7148JpgBYdJdgkK,
                      fullWidth: 4680,
                      fullHeight: 3120,
                      aspectRatio: undefined
                    }}
                  />
                </div>
              ) : null}
            </p.Stack>
          ) : null}
          <HomepageFooter
            data-plasmic-name={"homepageFooter"}
            data-plasmic-override={overrides.homepageFooter}
            className={classNames("__wab_instance", sty.homepageFooter)}
          />
        </p.Stack>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: ["root", "homepageNavbar", "whiteContainer", "homepageFooter"],
  homepageNavbar: ["homepageNavbar"],
  whiteContainer: ["whiteContainer"],
  homepageFooter: ["homepageFooter"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicAbout__ArgProps,
          internalVariantPropNames: PlasmicAbout__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicAbout__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicAbout";
  } else {
    func.displayName = `PlasmicAbout.${nodeName}`;
  }
  return func;
}

export const PlasmicAbout = Object.assign(
  // Top-level PlasmicAbout renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    homepageNavbar: makeNodeComponent("homepageNavbar"),
    whiteContainer: makeNodeComponent("whiteContainer"),
    homepageFooter: makeNodeComponent("homepageFooter"),
    // Metadata about props expected for PlasmicAbout
    internalVariantProps: PlasmicAbout__VariantProps,
    internalArgProps: PlasmicAbout__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicAbout;
/* prettier-ignore-end */
